import { DocsCallout, DocsCodeBlock } from "../components"

Adgiro does not estimate conversion values yet. If the site knows the value, send it explicitly.

<DocsCodeBlock language="js">
{`window.adgiroEvent("purchase", {
  value: 49.99,
  currency: "USD",
  transactionId: "order_123"
})`}
</DocsCodeBlock>

For known lead values, send the same shape:

<DocsCodeBlock language="js">
{`window.adgiroEvent("lead", {
  value: 250,
  currency: "USD",
  transactionId: "lead_123"
})`}
</DocsCodeBlock>

Values are forwarded to Google Ads click conversion uploads and Meta Conversions API when the
event is mapped and the provider has enough click or identity signal.

<DocsCallout title="Future value drivers">
  Commerce integrations such as Shopify, Magento, and WordPress can later compute these same
  fields and call the same event API.
</DocsCallout>
